exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*# sourceMappingURL=src/components/account/IntegratedWallet/ResponsibleGaming.css.map */", "", {"version":3,"sources":["D:/Build/PSWS/repositories/playsports-psws/PlaySports Web Site - Monarch Casino Resort - Colorado/tag/2.27.49.0/1092204/Generic/Source/src/components/account/IntegratedWallet/ResponsibleGaming.vue"],"names":[],"mappings":"AAAA,yFAAyF","file":"ResponsibleGaming.vue","sourcesContent":["/*# sourceMappingURL=src/components/account/IntegratedWallet/ResponsibleGaming.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea994458","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/IntegratedWallet/ResponsibleGaming.vue
// module id = W94R
// module chunks = 12